<template>
    <span>
         <span  v-show="enabled">
            <slot :scope="scope"></slot>
         </span>
         <span style="display:inline-block;margin-left:0px;float:right" v-for="doc in docs" v-bind:key="doc.DOCUMENT_ID">
            <div style="position: relative;width: 80px;height:80px;display: inline-block;margin-left: 10px;margin-bottom: 10px;margin-top:5px;background-color: #fff;cursor: pointer;">
                <span :title="doc.S_ORIGINAL_NAME"><img class="thumbImg" style="width:100%;height:100%" :src="doc.thumbSrc"
                 :data-caption="doc.S_ORIGINAL_NAME" :data-group="id" data-magnify="gallery"  :data-src="doc.src"></span>
                <span class="layui-layer-setwin"  title="删除图片"><a class="layui-layer-ico  layui-layer-close2" v-show="enabled" @click="deleteFile(doc.DOCUMENT_ID)"></a></span>
            </div>
        </span>
     </span>
</template>
<script>
export default {
    name: 'LayuiImgUpload',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'LayuiImgUpload-' + window.uuid();
            },
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        uploadTitle: {
            type: String,
        },
        filters: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        max : {
            type: Number,
            default : -1
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data() {
        return {
            id: null,
            scope: this,
            docs : [],
            fileNum: 0
        }
    },
    mounted() {
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.tid = this.security.getUser().getToken();
        this.url = process.env.REPOSITORY_HOST + '/img/upload?token=' + this.tid;
    },
    methods: {
        upload() {
             if(this.max > 0 && this.fileNum == this.max) {
                this.layer.openAlert("只允许上传" + this.max + "张图片!");
                return;
            }
            var that = this;
            $("#" + this.id).remove();
            this.el.find('.layuiupload').attr("id", this.id);
            var uploadEl = this.getUploadTemplate();
            uploadEl = $(uploadEl);
            uploadEl.attr('id', this.id);
            $("body").append(uploadEl);
            this.layer.openPop(this.id, this.uploadTitle ? this.uploadTitle : '上传图片', null, 380, true);
            uploadEl.find(".filePlace").pluploadQueue({
                runtimes : 'html5,flash',
                url : that.url,
                unique_names : true,
                filters : this.filters.length > 0 ? [{title : "", extensions : this.filters.join(",")}] : "",
                init:{
                    FileUploaded: function(uploader,file,response){
                        if(response.response){
                            var result = JSON.parse(response.response);
                            if(result.error) {
                                console.error(result.error);
                            } else {
                                var addDoc = result.doc;
                                var obj = {};
                                for(var p in addDoc) {
                                    obj[p.toUpperCase()] = addDoc[p];
                                }
                                that.docs.push(that.wrapDoc(obj));
                                that.fileNum ++;
                                this.ui_update = true;
                                that.$emit('_modelEvent', that.buildValue());
                            }
                            that.layer.closePop(that.id)
                        }
                    },
                    UploadComplete: function(uploader,fs){
                        uploader.refresh();
                        uploader.destroy();//ie9以下若不销毁此对象第二次上传会十分缓慢
                    },
                    FilesAdded: function(uploader, files){
                        if(that.max > 0 && that.fileNum + uploader.files.length > that.max) {
                            while(uploader.files.length > 0){
                                uploader.removeFile(uploader.files[0]);
                            }
                            that.layer.openAlert("只允许上传" + that.max + "张图片!");
                            return;
                        }
                    },
                }
            });

        },
        getUploadTemplate() {
            return `<div class="layuiupload"style="display: none;">
                        <div class="filePlace"></div>
                        </div>
                    </div>`
        },
        deleteFile(docId){
             this.layer.openConfirm('确定要删除这张图片吗?', ()=> {
                for(var i = 0 ; i < this.docs.length; i ++) {
                    var doc = this.docs[i];
                    if(doc.DOCUMENT_ID == docId){
                        this.docs.remove(doc);
                        this.ui_update = true;
                        this.$emit('_modelEvent', this.buildValue());
                        return;
                    }
                }
            });
        },
        buildValue(){
            var value = [];
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                value.push(doc.DOCUMENT_ID);
            }
            return value.join(",");
        },
        setValue(value) {
            if(!this.ui_update) {
                if(!value) {
                    this.docs = [];
                } else {
                    this.api.queryList(
                            'DB_DOCUMENT',
                            {p2: {'DOCUMENT_ID:1': value}},
                            this.requestUniqueId
                    ).then(response => {
                        var results = response.result;
                        for(var i = 0; i < results.length; i++) {
                            var result = results[i];
                            if(!this.containsDoc(result.DOCUMENT_ID)) {
                                this.docs.push(this.wrapDoc(result));
                            }
                        }
                        this.fileNum = results.length;
                        this.$nextTick(()=> {
                            this.renderPictureView();
                        });
                    });
                }
            }
            this.ui_update = false;
             this.fileNum = this.docs.length;
        },
        containsDoc(docId) {
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                if(doc.DOCUMENT_ID == docId) {
                    return true;
                }
            }
        },
        renderPictureView(){
             this.el.find(".thumbImg").Magnify({
                    Toolbar: [
                        'prev',
                        'next',
                        'rotateLeft',
                        'rotateRight',
                        'zoomIn',
                        'actualSize',
                        'zoomOut'
                    ],
                    keyboard:true,
                    draggable:true,
                    movable:true,
                    modalSize:[800,600],
                });
        },
        wrapDoc(doc) {
            doc.src = process.env.REPOSITORY_HOST + '/img/get/' + doc.DOCUMENT_ID + '?token=' + this.tid;
            doc.thumbSrc = process.env.REPOSITORY_HOST + '/img/get/thumb/' + doc.DOCUMENT_ID + '?token=' + this.tid;
            return doc;
        }
    },
    watch:{
        _model(value){
           this.setValue(value);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiImgUpload.vue